import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class AddToCartServices {
  addToCartV2 = async (payload) => {
    const addProducts = await Helpers.post({
      url: Constants.ADD_TO_CART,
      data: payload,
    });
    return addProducts;
  }

  removeFromCartV2 = async (payload) => {
    const removeProducts = await Helpers.delete({
      url: Constants.ADD_TO_CART,
      data: payload,
    });
    return removeProducts;
  }

  getCartV2 = async ({ tenantId }) => {
    let url = `${Constants.ADD_TO_CART}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    const getCartReq = await Helpers.get({ url });
    return getCartReq;
  }
}

export default new AddToCartServices();
